import {TIMER_COLORS, TIMER_CRITICAL_THRESHOLD, TIMER_LOW_THRESHOLD} from '../constants'

export const TimerBadge = ({remaining, total}: {remaining: number; total: number}) => {
  const radius = 18
  const circumference = 2 * Math.PI * radius
  const pct = total > 0 ? remaining / total : 0
  const offset = circumference * (1 - pct)
  const isLow = remaining <= TIMER_LOW_THRESHOLD
  const isCritical = remaining <= TIMER_CRITICAL_THRESHOLD

  let strokeColor: string = TIMER_COLORS.normal

  if (isCritical) {
    strokeColor = TIMER_COLORS.critical
  } else if (isLow) {
    strokeColor = TIMER_COLORS.low
  }

  return (
    <div className="relative flex size-10 items-center justify-center">
      <svg className="-rotate-90" width={44} height={44} viewBox="0 0 44 44">
        <circle cx={22} cy={22} r={radius} fill="none" stroke="#3a3a3a" strokeWidth={2} />
        <circle
          cx={22}
          cy={22}
          r={radius}
          fill="none"
          stroke={strokeColor}
          strokeWidth={2}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className="transition-[stroke-dashoffset] duration-1000 ease-linear"
        />
      </svg>
      <span className="absolute text-13 font-medium tabular-nums text-moss-white">{remaining}</span>
    </div>
  )
}
